import { useEffect, useRef, useState } from 'react'
import { continueStreamReveal } from './continueStreamReveal'
import { revealStep } from './revealStep'

export function useStreamTextReveal(target, streaming) {
  const goal = String(target ?? '')
  const [revealed, setRevealed] = useState('')
  const revealedRef = useRef('')

  useEffect(() => {
    if (!streaming) {
      revealedRef.current = goal
      return undefined
    }
    let current = continueStreamReveal(revealedRef.current, String(target ?? ''))
    revealedRef.current = current
    setRevealed(current)
    let frame = 0
    const tick = () => {
      const nextGoal = String(target ?? '')
      current = continueStreamReveal(current, nextGoal)
      if (current.length < nextGoal.length) {
        current = nextGoal.slice(0, current.length + revealStep(nextGoal.length - current.length))
        revealedRef.current = current
        setRevealed(current)
      }
      frame = requestAnimationFrame(tick)
    }
    frame = requestAnimationFrame(tick)
    return () => cancelAnimationFrame(frame)
  }, [streaming, target, goal])

  if (!streaming) {
    return { displayText: goal, isRevealing: false }
  }
  return { displayText: revealed, isRevealing: revealed.length < goal.length }
}
